import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { isValidName } from '../common/utilities/Validations';
import {DYNAMIC_TABLE, ADD_UPDATE, getApiPath} from "../../api/ApiConst"
import apiCaller from "../../api/ApiCaller";
import { toast } from 'react-toastify';
import textUtils from '../common/utilities/TextUtils';

const TableCreate = (props) => {
    const [tableData, setTableData] = useState({
        id: "",
        name: "",
        description: "",
        pathValue: "",
        addDefaultAttribute: false,
        isMultiTenantTable: false,
    });

    const handleTextChange = (e, type) => {
        if (type === "text") {
            var flag = isValidName(e.target.value)
            if (e.target.name === "name") {
                if (!flag) {
                    return;
                }
                setTableData(prev => ({ ...prev, [e.target.id]: e.target.value }));
            }
            else if (e.target.name === "pathValue") {
                if (!flag) {
                    return;
                }
                setTableData(prev => ({ ...prev, [e.target.id]: e.target.value }));
            }
            else {
                setTableData(prev => ({ ...prev, [e.target.id]: e.target.value }));
            }
        } else if (type === "checkbox") {
            setTableData(prev => ({ ...prev, [e.target.id]: e.target.checked }));
        }
    }

    useEffect(() => {
        if (props.object != null) {
            setTableData(props.object);
        }
    }, [props.object]);

    const toggle = () => {
        props.close();
    }

    const handleCreateTable = async () => {
        let requestObj = tableData;
        if ((textUtils.isEmpty(requestObj.name, "Name", true)) ||
            (textUtils.isEmpty(requestObj.description, "Description", true)) ||
            (textUtils.isEmpty(requestObj.pathValue, "Path", true))) {
            return false;
        }

        let url = getApiPath(DYNAMIC_TABLE, ADD_UPDATE);
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            toast.success("Table Created Successfully");
            toggle();
            props.successCallBack()
        }, (error) => {
            toast.error(error);
        })
    }



    return (
        <>
            <Modal show={props.show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Table</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Name *</label>
                            <input
                                type="text"
                                placeholder="Table Name"
                                className="form-control"
                                autoComplete='off'
                                name='name'
                                id='name'
                                value={tableData.name}
                                onChange={(e) => handleTextChange(e, e.target.type)}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Description *</label>
                            <input
                                type="text"
                                placeholder="Description"
                                className="form-control"
                                autoComplete='off'
                                name='description'
                                id='description'
                                value={tableData.description}
                                onChange={(e) => handleTextChange(e, e.target.type)}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Path *</label>
                            <input
                                type="text"
                                placeholder="Path...."
                                className="form-control"
                                autoComplete='off'
                                name='pathValue'
                                id='pathValue'
                                value={tableData.pathValue}
                                onChange={(e) => handleTextChange(e, e.target.type)}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-6">
                                    <input
                                        type="checkbox"
                                        name="addDefaultAttribute"
                                        id="addDefaultAttribute"
                                        checked={tableData.addDefaultAttribute}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Add Default Attribute</label>
                                </div>
                                <div className="col-lg-6">
                                    <input
                                        type="checkbox"
                                        name="isMultiTenantTable"
                                        id="isMultiTenantTable"
                                        checked={tableData.isMultiTenantTable}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Multi Tenant Table</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' onClick={handleCreateTable}>Create</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default TableCreate
